import ClientsService from './ClientsService'

export default ClientsService
